import colors from '_containers/Theme/intheblack/colors';

export default {
  color: colors.all.brandPrimary1
};
